import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { interval, Subscription } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { environment } from '../../environments/environment';
import * as $ from 'jquery';
import { WindowRef } from '../service/WindowRef.service';
declare var $: any;

@Component({
  selector: 'app-senior-citizen-proposal-form',
  templateUrl: './senior-citizen-proposal-form.component.html',
  styleUrls: ['./senior-citizen-proposal-form.component.css']
})
export class SeniorCitizenProposalFormComponent implements OnInit {
 
  title:string;
  firstName:string;
  lastName:string
  mobile:number;
  email:string;
  dob:Date;
  address:string;
  gender:string;
  state:string;
  city:string;
  pincode:number;
  age:number;
  maritialStatus:string;
  nomineeTitle:string;
  nomineeFirstName:string;
  nomineeLastName:string;
  nomnineedob:Date;
  nomineeGender:string;
  nomineeRelation:string;
  spouseTitle:string;
  spouseFirstName:string;
  spouseLastName:string;
  spouseDob:Date;
  spouseGender:String;
  spouseRelationship:string
  sumAssured:string
  goodHealthDec:boolean;
  webTermsAndCond:boolean;
  appTermsAndCond:boolean;
  Relation:any=[];
  errorMessage:string;
  currentDate : string;
  premium:any;
  stateList:any=[];
  cityList:any=[];
  leadId:any;
  finalPremium:any;
  rzp1: any;
  secureNowTxnRefNo: string;
  txnId: string;
  loading:boolean;
  error :string;
  //for disabling div  in production
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService,  private winRef: WindowRef) {
     }


  ngOnInit() {

    this.title="Mr.";
    this.gender="";
    this.state="";
    this.city="";
    this.maritialStatus='';
    this.nomineeTitle='Mr.';
    this.nomineeGender='';
    this.nomineeRelation='';
    this.spouseTitle="Mr."
    this.spouseGender="";
    this.spouseRelationship=""
    this.goodHealthDec=false;
    this.appTermsAndCond=true;
    this.webTermsAndCond=true;
    this.age=Number(localStorage.getItem('seniorAge'));
    this.sumAssured=localStorage.getItem('sumAssured');
    this.premium=localStorage.getItem('premiumAmountSenior');
    this.currentDate = String(this.setDate())

    if(localStorage.getItem("seniorFamdef")=='Self Only'){
      this.maritialStatus='Single';
    }
    else if(localStorage.getItem("seniorFamdef")=='Self and Spouse'){
      this.maritialStatus='Married';
    }
 
    this.Relation = [
     {name:'Self', value:'Self'},
     {name:'Brother', value:'Brother'},
     {name:'Father', value:'Father'},
     {name:'Grandfather', value:'Grandfather'},
     {name:'Grandmother', value:'Grandmother'},
     {name:'Brother-In-Law', value:'Brother-In-Law'},
     {name:'Mother-In-Law', value:'Mother-In-Law'},
     {name:'Sister-In-Law', value:'Sister-In-Law'},
     {name:'Mother', value:'Mother'},
     {name:'Sister', value:'Sister'},
     {name:'Son', value:'Son'},
     {name:'Daughter', value:'Daughter'},
     {name:'wife', value:'wife'},
     {name:'Husband', value:'Husband'},
    ]

    this.Relation.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
    
    this.callStateAPI()
   }

    setDate = () => {
    var dtToday = new Date();
    var day
    var month;
    var months = dtToday.getMonth() + 1;
    var days = dtToday.getDate();
    var year = dtToday.getFullYear();
    if (months < 10)
      month = '0' + months.toString();
    else
      month = months.toString();

    if (days < 10)
      day = '0' + days.toString();
    else  
      day = days.toString();

    var maxDate = year + '-' + month + '-' + day;
    return maxDate
  }

  handlingEvents(event: any){
 
    if(event.target.name=='mobile'){
      const pattern = /[0-9\+\-\ ]/;

      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    }

    if(event.target.name=='pincode'){
      const pattern = /[0-9\+\-\ ]/;

      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
    
  }

  callStateAPI(){
    this.serviceURLService.getAllStateList().pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {   
    this.stateList = successData.data
    this.stateList.sort((a, b) => a.stateName.toLowerCase() > b.stateName.toLowerCase() ? 1 : -1);
    }, errorData => {
      
    })
    this.city=""
  }

  callCityListAPI(event){
   
    // this.state = this.stateList.filter(f=>f.stateCode==event.target.value)[0].stateName
    // console.log(this.stateList.filter(f=>f.stateCode==event.target.value)[0].stateName, "statte")
    this.serviceURLService.getAllCityList(event.target.value).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {   
      this.cityList = successData.data
    this.cityList.sort((a, b) => a.cityName.toLowerCase() > b.cityName.toLowerCase() ? 1 : -1);
    }, errorData => {
      
    })
  }

   buyInsurance(){
     console.log(this.errorMessage, "hello")
   
     if(this.title==''){
       this.errorMessage = 'Person Title is Required';
       return;
     }
     else if(this.firstName==undefined || this.firstName==null || this.firstName==''){
      this.errorMessage = 'Person First Name is Required';
      return;
     }
     else if(this.lastName==undefined || this.lastName==null || this.lastName==''){
      this.errorMessage = 'Person Last Name is Required';
      return;
     }
     else if(this.mobile==undefined || this.mobile==null){
      this.errorMessage = 'Mobile Number is Required';
      return;
     }
     else if(String(this.mobile).length!=10){
      this.errorMessage = 'Mobile Number is Invalid';
      return;
     }
     else if(String(this.mobile).charAt[0]=='0'){
      this.errorMessage = 'Mobile Number Should not Start with 0 ';
      return;
     }
     else if(this.email==undefined || this.email == null || this.email==''){
      this.errorMessage = 'Email Id is Required';
      return;
     }
     else if (!this.validateEmail(this.email)) {
      this.errorMessage = 'Email Id is Invalid';
      return;
     }
     else if (this.dob==undefined || this.dob==null) {
      this.errorMessage = 'Date of Birth is Required';
      return;
     }
     else if (this.address==undefined || this.address==null || this.address=='') {
      this.errorMessage = 'Address is Required';
      return;
     }
     else if (this.gender=='') {
      this.errorMessage = 'Person Gender is Required';
      return;
     }
     else if (this.state=='') {
      this.errorMessage = 'Person State is Required';
      return;
     }
     else if (this.city=='') {
      this.errorMessage = 'Person City is Required';
      return;
     }
     else if(this.pincode==undefined || this.pincode==null){
      this.errorMessage = 'Pincode is Required';
      return;
     }
     else if(String(this.pincode).length!=6){
      this.errorMessage = 'Pincode is Invalid';
      return;
     }
     else if(this.age==undefined || this.age==null){
      this.errorMessage = 'Person Age is Required';
      return;
     }
     else if(this.maritialStatus==''){
      this.errorMessage = 'Maritial Status is Required';
      return;
     }
    else if(this.nomineeTitle==undefined || this.nomineeTitle==null){
      this.errorMessage = 'Nominee Title is Required';
      return;
    }
    else if(this.nomineeFirstName==undefined || this.nomineeFirstName==null ||  this.nomineeFirstName==''){
     this.errorMessage = 'Nominee First Name is Required';
     return;
    }
    else if(this.nomineeLastName==undefined || this.nomineeLastName==null || this.nomineeLastName==''){
     this.errorMessage = 'Nominee Last Name is Required';
     return;
    }
    else if (this.nomnineedob==undefined || this.nomnineedob==null) {
      this.errorMessage = 'Nominee Date of Birth is Required';
      return;
     }
     else if(this.nomineeGender==''){
      this.errorMessage = 'Nominee Gender is Required';
      return;
     }
     else if(this.nomineeRelation==''){
      this.errorMessage = 'Nominee Relation is Required';
      return;
     }else if(!this.appTermsAndCond){
      this.errorMessage = 'Please accept Terms & Condition of the Securenow App';
      return;
     }
     else if(!this.webTermsAndCond){
      this.errorMessage = 'Please accept Terms & Condition of the Purchase of this Policy.';
      return;
     }
     else{
      this.errorMessage = '';
       if(this.goodHealthDec){
        console.log("validation Successfull...going to save Data")
        this.saveSeniorData()
       }
       else{
         $("#thankyou").modal("show");
       }
     }
   }

   closeDeclarationModal=()=>{
    $("#thankyou").modal("hide");
   }

  validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  initiatePaymentForSeniorCitizen() {
    // console.log("in initiate payment generali ",loi)
    this.loading = true;
    let  data = {
      'premium': this.finalPremium,
      'leadId': this.leadId
    }
    this.serviceURLService.initiatePaymentForSeniorCitizen(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;

      this.txnId = successData.data.transactionId;
      localStorage.setItem("txnId",successData.data.razorPayOrderId );
      localStorage.setItem("txnRefNo", successData.data.secureNowTxnRefNo)
      this.router.navigate(['razorpay'],{ queryParams: { txnId: successData.data.razorPayOrderId, txnRefNo: successData.data.secureNowTxnRefId}});
      //this.initPay();

    }, errorData => {
      console.log("Oops..!! Error");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  // initPay(){
  //   // console.log("intipay txnId ",this.txnId);
  //   this.options.order_id =  this.txnId;
  //     this.rzp1 = new this.winRef.nativeWindow.Razorpay(this.options);
  //     this.rzp1.open();
  // }

   saveSeniorData(){
    let data = {}
    if(this.maritialStatus==='Single'){
      data = {
      Salutation: this.title,
      First_Name: this.firstName,
      Last_Name: this.lastName,
      Address: this.address,
      Pin_Code: this.pincode,
      State: this.stateList.filter(f=>f.stateCode==this.state)[0].stateName,
      City: this.city,
      Phone_No: this.mobile,
      Email: this.email,
      Gender: this.gender,
      Date_Of_Birth: this.dob,
      Age: this.age,
      Marital_status: this.maritialStatus,
      Nominee_Name: this.nomineeFirstName+" "+ this.nomineeLastName,
      Nominee_Date_Of_Birth: this.nomnineedob,
      Nominee_Relation: this.nomineeRelation,
      Declaration: this.goodHealthDec,
      Sum_Assured:this.sumAssured,
      action:"buy",
      PREMIUM:this.premium,
      orgLinkName:"SecureNow-FHI-Senior-Citizen-Plan",
      calculatorId:"0e24db08-7b78-443b-b0ac-0068d27f62ca"
     }
    }else{
       data = {
        Salutation: this.title,
        First_Name: this.firstName,
        Last_Name: this.lastName,
        Address: this.address,
        Pin_Code: this.pincode,
        State: this.state,
        City: this.city,
        Phone_No: this.mobile,
        Email: this.email,
        Gender: this.gender,
        Date_Of_Birth: this.dob,
        Age: this.age,
        Marital_status: this.maritialStatus,
        Nominee_Name: this.nomineeFirstName+" "+ this.nomineeLastName,
        Nominee_Date_Of_Birth: this.nomnineedob,
        Nominee_Relation: this.nomineeRelation,
        Spouse_First_Name:this.spouseFirstName,
        Spouse_Last_Name:this.spouseLastName,
        Spouse_Date_Of_Birth:this.spouseDob,
        Spouse_Gender:this.spouseGender,
        Spouse_Relation:this.spouseRelationship,
        Declaration: this.goodHealthDec,
        Sum_Assured:this.sumAssured,
        action:"buy",
        PREMIUM:this.premium,
        orgLinkName:"SecureNow-FHI-Senior-Citizen-Plan",
        calculatorId:"0e24db08-7b78-443b-b0ac-0068d27f62ca"
       }
    }

    this.serviceURLService.SavingDataInPlatform(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {   
      this.errorMessage = successData.message;
      this.leadId = successData.leadId;
      this.finalPremium = successData.premium
      this.initiatePaymentForSeniorCitizen()
    }, errorData => {
      
    })
   }
 
}